import type { IconDef } from '../types';

export const search: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22.5 21.2924L17.8847 16.3459C17.8847 16.3459 17.8123 16.2819 17.7671 16.2453C19.0969 14.5358 19.893 12.3874 19.893 10.0562C19.902 4.507 15.4421 0 9.951 0C4.45986 0 0 4.507 0 10.0562C0 15.6054 4.45986 20.1124 9.951 20.1124C11.9864 20.1124 13.8862 19.4907 15.4602 18.4211C15.4874 18.4577 15.5055 18.4943 15.5416 18.5308L20.157 23.4773C20.4555 23.8064 20.8536 23.9801 21.2606 23.9984C21.6677 24.0167 22.0839 23.8795 22.4095 23.5779C23.0609 22.9745 23.1061 21.9597 22.509 21.3015L22.5 21.2924ZM5.65398 17.0407C2.1259 14.8283 1.18507 9.89164 3.55522 6.03372C5.92537 2.1758 10.7199 0.850206 14.248 3.07171C17.7761 5.28407 18.7169 10.2208 16.3468 14.0787C13.9766 17.9366 9.18206 19.2622 5.65398 17.0498V17.0407Z',
    },
  ],
};
